'use client';

import Link from 'next/link';
import MarketingHeader from '@/components/MarketingHeader';
import MarketingFooter from '@/components/MarketingFooter';
import { getBrandHomeUrl } from '@/lib/creatorPlatformUrls';

export default function CareersPage() {
  return (
    <div className="home-page">
      <MarketingHeader />
      <main className="about-main">
        <h1 className="home-about-title">加入我们</h1>
        <p className="home-about-text about-main-careers-tagline">与创作者站在一起，让每一份才华都有回响。</p>
        <div className="about-main-careers-body">
          <p className="home-about-text about-main-contact-intro">
            基音正在寻找对音乐与创作者生态有热情、愿意与团队一起成长的伙伴。无论您擅长产品、技术、运营还是内容，都欢迎将简历发送至下方邮箱，我们会在收到后尽快与您联系。
          </p>
          <p className="home-about-text about-main-careers-resume">简历投递：hr@fundamuse.com</p>
        </div>
        <p style={{ marginTop: '4rem', fontSize: '0.875rem' }}>
          <Link href={getBrandHomeUrl()} className="link-hover">&lt; 返回首页</Link>
        </p>
      </main>
      <MarketingFooter />
    </div>
  );
}
